import { Report } from '@/api/generatedApi';
import { LIST_REPORTS_QUERY_KEY } from '@/hooks/api/reports/useFetchListReports';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQueryClient } from '@tanstack/react-query';
import { BulkDeleteModal } from './BulkDeleteModal';

export const BulkDeleteReportsModal = ({
  open,
  onClose,
  selectedReports,
  onDeleteComplete,
}: {
  open: boolean;
  onClose: () => void;
  selectedReports: Report[];
  onDeleteComplete?: () => void;
}) => {
  const { getTenantId } = useTenants();
  const queryClient = useQueryClient();

  const handleDeleteComplete = () => {
    queryClient.resetQueries({
      queryKey: [LIST_REPORTS_QUERY_KEY],
      exact: false,
    });
    onDeleteComplete?.();
  };

  return (
    <BulkDeleteModal
      open={open}
      onClose={onClose}
      selectedItems={selectedReports}
      onDeleteComplete={handleDeleteComplete}
      deleteItem={async report => {
        await api.reports.deleteReport(getTenantId(), report.id);
      }}
      itemLabel={{ singular: 'report', plural: 'reports' }}
    />
  );
};
